import { BusinessTypeLimitedCompany, BusinessTypeLimitedLiabilityCompany, BusinessTypePartnershipCompany, BusinessTypeSoleTrader } from '../localeConstants/quote';
/**
 * Greate american: Down payment ratio
 */

export var downPaymentRatioMap = {
  '25': {
    value: 25,
    label: '25%'
  } // '8': { value: 8, label: '8%' },

};
export var downPaymentRatioList = Object.values(downPaymentRatioMap);
/**
 * Greate american: Type of removal job
 */

export var greateAmericanTypeOfOperationCourier = 'courier';
export var greateAmericanTypeOfOperationHouseholdGoods = 'householdGoods';
export var greateAmericanTypeOfOperationAutomobileHauler = 'automobileHauler';
export var greateAmericanTypeOfOperationDoubleTrailers = 'doubleTrailers';
export var greateAmericanTypeOfOperationRefrigeratedFreight = 'refrigeratedFreight';
export var typeOfOperationList = [{
  value: greateAmericanTypeOfOperationCourier,
  label: 'Courier'
}, {
  value: greateAmericanTypeOfOperationHouseholdGoods,
  label: 'Household Goods'
}, {
  value: greateAmericanTypeOfOperationAutomobileHauler,
  label: 'Automobile Hauler'
}, {
  value: 'other',
  label: 'Other'
}];
export var otherTypeOfOperationList = [{
  value: 'containerizedFreight',
  label: 'Contanerized freight'
}, {
  value: greateAmericanTypeOfOperationDoubleTrailers,
  label: 'Double trailers'
}, {
  value: 'flatBed',
  label: 'Flat Bed'
}, {
  value: 'mobileHauler',
  label: 'Mobile home hauler'
}, {
  value: greateAmericanTypeOfOperationRefrigeratedFreight,
  label: 'Refridgerated freight'
}, {
  value: 'Wrecker/ Tower',
  label: 'Wrecker/ Tower'
}];
/**
 * Greate american: Average radius operation
 */

export var averageRadiusOfOperationList = [{
  value: '150',
  label: '0-150 Miles'
}, {
  value: '300',
  label: '151-300 Miles'
}, {
  value: '500',
  label: '301-500 Miles'
}, {
  value: '1000',
  label: '501-1000 Miles'
}, {
  value: '1000PLUS',
  label: '1001+ Miles'
}];
/**
 * Greate american: business type
 */

export var greateAmericanBusinessTypeList = [{
  value: BusinessTypeSoleTrader,
  label: 'Sole proprietorship'
}, {
  value: BusinessTypePartnershipCompany,
  label: 'Partnership'
}, {
  value: BusinessTypeLimitedCompany,
  label: 'Corporation'
}, {
  value: BusinessTypeLimitedLiabilityCompany,
  label: 'Limited liability company (LLC)'
}];
/**
 * Greate american: Years of experience
 */

export var greateAmericanYearsOfExperienceList = [{
  value: 'YIB4',
  label: 'Over 5 years under current authority'
}, {
  value: 'YIB0',
  label: '3-5 years under current authority'
}, {
  value: 'YIB1',
  label: '1-2 years under current authority'
}, {
  value: 'YIB2',
  label: 'New Venture with 2+ years experience'
}, {
  value: 'YIB3',
  label: 'New venture with no prior experience'
}];
/**
 * Greate american: State
 */

export var GreateAmericanStateList = [{
  value: 'AL',
  label: 'Alabama'
}, {
  value: 'AK',
  label: 'Alaska'
}, {
  value: 'AZ',
  label: 'Arizona'
}, {
  value: 'AR',
  label: 'Arkansas'
}, {
  value: 'CA',
  label: 'California'
}, {
  value: 'CO',
  label: 'Colorado'
}, {
  value: 'CT',
  label: 'Connecticut'
}, {
  value: 'DC',
  label: 'District of Columbia'
}, {
  value: 'DE',
  label: 'Delaware'
}, {
  value: 'FL',
  label: 'Florida'
}, {
  value: 'GA',
  label: 'Georgia'
}, {
  value: 'HI',
  label: 'Hawaii'
}, {
  value: 'ID',
  label: 'Idaho'
}, {
  value: 'IL',
  label: 'Illinois'
}, {
  value: 'IN',
  label: 'Indiana'
}, {
  value: 'IA',
  label: 'Iowa'
}, {
  value: 'KS',
  label: 'Kansas'
}, {
  value: 'KY',
  label: 'Kentucky'
}, {
  value: 'LA',
  label: 'Louisiana'
}, {
  value: 'ME',
  label: 'Maine'
}, {
  value: 'MD',
  label: 'Maryland'
}, {
  value: 'MA',
  label: 'Massachusetts'
}, {
  value: 'MI',
  label: 'Michigan'
}, {
  value: 'MN',
  label: 'Minnesota'
}, {
  value: 'MS',
  label: 'Mississippi'
}, {
  value: 'MO',
  label: 'Missouri'
}, {
  value: 'MT',
  label: 'Montana'
}, {
  value: 'NE',
  label: 'Nebraska'
}, {
  value: 'NV',
  label: 'Nevada'
}, {
  value: 'NH',
  label: 'New Hampshire'
}, {
  value: 'NJ',
  label: 'New Jersey'
}, {
  value: 'NM',
  label: 'New Mexico'
}, {
  value: 'NY',
  label: 'New York'
}, {
  value: 'NC',
  label: 'North Carolina'
}, {
  value: 'ND',
  label: 'North Dakota'
}, {
  value: 'OH',
  label: 'Ohio'
}, {
  value: 'OK',
  label: 'Oklahoma'
}, {
  value: 'OR',
  label: 'Oregon'
}, {
  value: 'PA',
  label: 'Pennsylvania'
}, {
  value: 'RI',
  label: 'Rhode Island'
}, {
  value: 'SC',
  label: 'South Carolina'
}, {
  value: 'SD',
  label: 'South Dakota'
}, {
  value: 'TN',
  label: 'Tennessee'
}, {
  value: 'TX',
  label: 'Texas'
}, {
  value: 'UT',
  label: 'Utah'
}, {
  value: 'VT',
  label: 'Vermont'
}, {
  value: 'VA',
  label: 'Virginia'
}, {
  value: 'WA',
  label: 'Washington'
}, {
  value: 'WV',
  label: 'West Virginia'
}, {
  value: 'WI',
  label: 'Wisconsin'
}, {
  value: 'WY',
  label: 'Wyoming'
}];
/**
 * Greate american: Cover
 */

export var greateAmericanCoverMap = {
  prePowerUnit: {
    value: 'pre-power-unit',
    label: 'Motor truck cargo'
  },
  deductible: {
    value: 'deductible',
    label: 'Deductible'
  },
  reloading: {
    value: 'reloading',
    label: 'Reloading'
  },
  debrisRemoval: {
    value: 'debris-removal',
    label: 'Debris removal'
  },
  earnedFreight: {
    value: 'earned-freight',
    label: 'Earned freight'
  },
  fireDepartment: {
    value: 'fire-department',
    label: 'Fire department'
  },
  lossData: {
    value: 'loss-data',
    label: 'Loss data'
  },
  rewardCoverage: {
    value: 'reward-coverage',
    label: 'Reward Coverage'
  },
  pollutantCleanUp: {
    value: 'pollutant-clean-up',
    label: 'Pollutant Clean Up'
  },
  refrigerationBreakdown: {
    value: 'refrigeration-breakdown',
    label: 'Refrigeration breakdown'
  },
  ownersGoodsExtension: {
    value: 'owners-goods-extension',
    label: 'Owners goods extension'
  },
  ownersGoodsExtensionNumber: {
    value: 'owners-goods-extension-number',
    label: 'Owners goods extension number'
  },
  nonOwnedTrailer: {
    value: 'non-owned-trailer',
    label: 'Non-Owned trailer / container coverage'
  },
  nonOwnedTrailerNumber: {
    value: 'non-owned-trailer-number',
    label: 'Non-owned trailer number '
  },
  nonOwnedTrailerLimit: {
    value: 'non-owned-trailer-limit',
    label: 'Non-owned trailer limit'
  },
  reusablePackingContainers: {
    value: 'reusable-packing-containers',
    label: 'Reusable packing containers'
  },
  reusablePackingContainersLimit: {
    value: 'reusable-packing-containers-limit',
    label: 'Reusable packing containers limit'
  },
  tarpsChains: {
    value: 'tarps-chains',
    label: 'Tarps, chains and moving equipment'
  },
  tarpsChainsLimit: {
    value: 'tarps-chains-limit',
    label: 'Tarps chains limit'
  },
  subhaulerOwnerPperator: {
    value: 'subhauler-owner-operator',
    label: 'Subhauler or owner operator '
  }
};
export var greateAmericanCoverList = Object.values(greateAmericanCoverMap);